document.addEventListener('DOMContentLoaded', function(){
  if (window.CustomDiscountInnited !== undefined) {
    return;
  }

  CustomDiscountInnited = true;
  let discountForms = document.querySelectorAll('.custom-discount-form');

  discountForms.forEach(form => {
    let settingsId = form.dataset.settings;
    if (settingsId == null || settingsId == undefined) {
      return;
    }
    let discountsJson = JSON.parse(document.querySelector('.promocodes[data-id="'+settingsId+'"]').innerText);
    let discountedProducts = JSON.parse(document.querySelector('.discounted_product_ids[data-id="'+settingsId+'"]').innerText);
    let formBtn = form.querySelector('[type="submit"]');
    let errorMessage = form.querySelector('.error');

    if (discountsJson.length && discountedProducts.length) {
      formBtn.removeAttribute('disabled');
      
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        formBtn.classList.add('loading');
        formBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        let codeField = form.querySelector('[name="code"]');
  
        if (matchesAnyCode(codeField.value, discountsJson)) {
          if (errorMessage) {
            errorMessage.classList.add('hidden');
          }

          addToCartWithADiscount(codeField.value, discountedProducts);
        } else {
          formBtn.classList.remove('loading');
          formBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (errorMessage) {
            errorMessage.classList.remove('hidden');
          }
        }
        
      });
    }
  });

  function matchesAnyCode(input, entries) {
    var value = (input || '').trim();
    if (!value) return false;
    var upper = value.toUpperCase();

    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (!entry) continue;
      var trimmed = String(entry).trim();
      if (!trimmed) continue;

      var lower = trimmed.toLowerCase();
      if (lower.indexOf('prefix:') === 0) {
        var prefix = trimmed.slice(7).trim();
        if (prefix && upper.indexOf(prefix.toUpperCase()) === 0) return true;
      } else if (lower.indexOf('regex:') === 0) {
        var pattern = trimmed.slice(6).trim();
        if (!pattern) continue;
        try {
          if (new RegExp(pattern, 'i').test(value)) return true;
        } catch (e) { /* invalid regex, skip */ }
      } else {
        if (trimmed.toUpperCase() === upper) return true;
      }
    }
    return false;
  }

  function addToCartWithADiscount(discount, discountedProducts) {
    
    fetch(window.Shopify.routes.root + 'discount/' + discount, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json'
      },
    }).then(response => {
    
      let items = [];
      discountedProducts.map(function(id) {
        items.push({
          'id': id,
          'quantity': 1
        });
      });
      
      
      let formData = {
       'items': items
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        console.log('code applied');
        location.href = window.Shopify.routes.root + 'cart';
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    });
  }
  
});